const arrayOrOnlyItem = (object) => {
  if(Array.isArray(object)) {
    if(object.length === 1) return arrayOrOnlyItem(object[0])
    return object.map(child => arrayOrOnlyItem(child))
  }
  return object
}

module.exports = arrayOrOnlyItem